import { SettingsForm } from "@circle-react/components/QuickPostV2/Settings/Form";
import { Header } from "./Header";

export const Settings = () => (
  <div className="h-full overflow-auto">
    <Header />
    <SettingsForm />
  </div>
);
